// @ts-strict-ignore
import React, { useState } from 'react'
import { Card, Field, Label, Input, Select, Button } from '../../../../atoms'
import { calculateTotalInterestAndPeriod } from '../../../helpers/mortgages-calculations'

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const getFormattedDate = (value: any) =>
  new Date(new Date().setMonth(new Date().getMonth() + value))

const calculateBalanceTransferFee = (balance, fee, amount, months, apr) => {
  const newBalance = balance * (1 + fee / 100) - amount * months
  const resultnew = calculateTotalInterestAndPeriod(newBalance, apr, amount)
  return resultnew
}

const formatThousands = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

const CreditCardCalculator = () => {
  const [cardBalance, setCardBalance] = useState(3500)
  const [cardApr, setCardApr] = useState(18)
  const [monthlyRepayment, setMonthlyRepayment] = useState(95)
  const [months, setMonths] = useState(24)
  const [fee, setFee] = useState(1.4)

  const result = calculateTotalInterestAndPeriod(cardBalance, cardApr, monthlyRepayment)

  const formattedDate = getFormattedDate(result.period)

  const BTresult = calculateBalanceTransferFee(cardBalance, fee, monthlyRepayment, months, cardApr)

  const dueDatePeriod = getFormattedDate(BTresult.period + months)

  const cardOffBalance = BTresult.total + months * monthlyRepayment

  return (
    <div>
      <h1 className='CreditCardCalculator__title'>Credit card interest calculator</h1>
      <h3 className='CreditCardCalculator__subtitle'>
        Find the total cost of your credit card and how long it will take to pay off.
      </h3>
      <div className='CreditCardCalculator Calculator'>
        <Card variant='plum'>
          <div className='inner-card'>
            <Field stack={true}>
              <Label>Card balance</Label>
              <Input
                value={cardBalance}
                onChange={(e) => setCardBalance(e.target.value)}
                type='text'
                prefix='£'
                format='thousands'
              />
            </Field>

            <Field stack={true}>
              <Label>Card APR</Label>
              <Input
                value={cardApr}
                onChange={(e) => setCardApr(e.target.value)}
                type='number'
                suffix='%'
              />
            </Field>

            <Field stack={true}>
              <Label>Monthly repayment</Label>
              <Input
                value={monthlyRepayment}
                onChange={(e) => setMonthlyRepayment(e.target.value)}
                type='text'
                prefix='£'
                format='thousands'
              />
            </Field>
          </div>

          {result.error ? (
            <h3 style={{ marginTop: 48 }}>{result.error}</h3>
          ) : (
            <>
              <h3 style={{ marginTop: 48 }}>
                Total repayable over {result.period} months{' '}
                <span>£{formatThousands(result.total)}</span>
              </h3>
              <h3>
                Final repayment due{' '}
                <span>
                  {monthNames[formattedDate.getMonth()]} {formattedDate.getFullYear()}
                </span>
              </h3>
              <h4>
                Transfering your debt onto a <span>0% balance transfer card</span> could save you
                money:
              </h4>

              <div className='inner-card' style={{ justifyContent: 'space-evenly' }}>
                <Field stack={true}>
                  <Label>Months</Label>
                  <Select
                    name='months'
                    value={months}
                    options={'.'
                      .repeat(98)
                      .split('')
                      .map((_, i) => ({ value: i + 1, text: i + 1 }))}
                    onChange={(e) => setMonths(e.target.value)}
                  />
                </Field>

                <Field stack={true}>
                  <Label>Fee</Label>
                  <Select
                    name='personal-monthly-contribution'
                    value={fee}
                    options={'.'
                      .repeat(51)
                      .split('')
                      .map((_, i) => ({ value: i / 10, text: `${i / 10} %` }))}
                    onChange={(e) => setFee(e.target.value)}
                  />
                </Field>
              </div>

              <h3>
                You could save{' '}
                <span>£{formatThousands(Math.ceil(result.total - cardOffBalance))}</span>
              </h3>
              <h4>
                By switching to a 0% balance transfer card for <span>{months}</span> months and a
                one-off fee of <span>{fee}%</span>, you would pay your card off by{' '}
                <span>{`${
                  monthNames[dueDatePeriod.getMonth()]
                } ${dueDatePeriod.getFullYear()}`}</span>{' '}
                and pay a total of{' '}
                <span>£{formatThousands(Math.ceil(cardOffBalance - monthlyRepayment))}</span> in
                fees and interest.
              </h4>

              <div className='cc-calc-button-wrapper'>
                <Button variant='primary' href='/credit-cards/eligibility-checker?productType=BT'>
                  See balance transfer cards
                </Button>
              </div>
            </>
          )}
        </Card>
      </div>
    </div>
  )
}

export default CreditCardCalculator
